import { CssBaseline, CssVarsProvider } from '@healthinal/ui';
import { QueryClientProvider } from '@tanstack/react-query';
import { createRouter, RouterProvider } from '@tanstack/react-router';
import { Provider as JotaiProvider } from 'jotai';
import React from 'react';
import ReactDOM from 'react-dom/client';
import 'react-toastify/dist/ReactToastify.css';
import { queryClient } from './api/queryClient.ts';
import { AuthenticationGate } from './components/AuthenticationGate.tsx';
import { NotFoundCard } from './components/errors/ErrorCard.tsx';
import { SplashScreen } from './components/SplashScreen.tsx';
import { ToastContainer } from './components/ToastContainer.tsx';
import { routeTree } from './routeTree.gen';
import { setupSentry } from './sentry.ts';
import { theme } from './theme.ts';

setupSentry();

const router = createRouter({
  routeTree,
  defaultNotFoundComponent: NotFoundCard,
  defaultPendingComponent: SplashScreen,
});
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <CssVarsProvider theme={theme} defaultMode="dark">
      <CssBaseline />
      <QueryClientProvider client={queryClient}>
        <AuthenticationGate>
          <JotaiProvider>
            <RouterProvider router={router} />
          </JotaiProvider>
        </AuthenticationGate>
      </QueryClientProvider>
      <ToastContainer />
    </CssVarsProvider>
  </React.StrictMode>,
);
